<script lang="ts">
    import type { Snippet } from "svelte";
    import { LL } from "../../../i18n/i18n-svelte";
    import { StringUtils } from "../../Utils/StringUtils";
    import Chip from "../UI/Chip.svelte";
    import { IconMicrophoneOff, IconCheck } from "@wa-icons";

    let editMode = $state(false);
    interface Props {
        selectedDevice?: string;
        deviceList: MediaDeviceInfo[];
        onselectdevice?: (deviceId: string | undefined) => void;
        icon?: Snippet;
        title?: Snippet;
        widget?: Snippet;
    }

    let { selectedDevice = undefined, deviceList, onselectdevice, icon, title, widget }: Props = $props();
</script>

<div
    class="w-full min-w-0 rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] p-4 text-[var(--nutrivera-shell-text)]"
>
    <div class="text-lg bold flex items-center gap-3 mb-4 ps-2">
        {@render icon?.()}
        <div class="grow pe-8 ps-2">
            {@render title?.()}
        </div>
        <button
            class="nutrivera-entry-secondary px-3"
            onclick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                editMode = !editMode;
            }}
        >
            {!editMode ? $LL.actionbar.edit() : $LL.actionbar.cancel()}
        </button>
    </div>

    <div class="flex w-full">
        <div class="flex flex-wrap justify-center w-full min-h-[129px]">
            <!-- svelte-ignore a11y_click_events_have_key_events -->
            <!-- svelte-ignore a11y_no_static_element_interactions -->
            <div
                class="nutrivera-entry-option flex w-full cursor-pointer items-center justify-start space-x-4 overflow-hidden px-8 py-6 {!selectedDevice
                    ? ''
                    : 'pt-4'}"
                class:hidden={!editMode && selectedDevice}
                class:flex={editMode || !selectedDevice}
                data-selected={!selectedDevice}
                onclick={() => {
                    onselectdevice?.(undefined);
                    editMode = false;
                }}
            >
                <div
                    class="me-4 flex aspect-square h-6 items-center justify-center rounded-full border border-solid border-[var(--nutrivera-shell-border)] {!selectedDevice
                        ? 'border-[var(--nutrivera-shell-accent)] bg-[var(--nutrivera-shell-accent)]'
                        : ''}"
                >
                    {#if !selectedDevice}
                        <IconCheck font-size="20" class="text-[var(--nutrivera-shell-accent-ink)]" />
                    {/if}
                </div>

                <div class="space-y-1 min-w-0">
                    <div class="text-lg bold truncate leading-tight flex self-start">
                        {#if editMode && selectedDevice}
                            <IconMicrophoneOff font-size="20" />
                        {/if}

                        {$LL.audio.disable()}
                    </div>
                    {#if !selectedDevice}
                        <Chip class="nutrivera-entry-muted">{$LL.camera.active()}</Chip>
                    {:else}
                        <Chip class="nutrivera-entry-muted">{$LL.camera.notRecommended()}</Chip>
                    {/if}
                </div>
            </div>
            {#each deviceList ?? [] as device (device.deviceId)}
                <!-- svelte-ignore a11y_click_events_have_key_events -->
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <div
                    class="nutrivera-entry-option relative w-full cursor-pointer space-x-4 overflow-hidden px-8 py-6 {selectedDevice ===
                    device.deviceId
                        ? 'pt-12'
                        : 'pt-4'}"
                    class:hidden={!editMode && selectedDevice !== device.deviceId}
                    class:flex={editMode || selectedDevice === device.deviceId}
                    data-selected={selectedDevice === device.deviceId}
                    onclick={() => {
                        onselectdevice?.(device.deviceId);
                        editMode = false;
                    }}
                >
                    {#if device.deviceId === selectedDevice}
                        {@render widget?.()}
                    {/if}
                    <div class="flex gap-4 items-center justify-start w-full">
                        <div
                            class="flex aspect-square h-6 items-center justify-center rounded-full border border-solid border-[var(--nutrivera-shell-border)] {selectedDevice ===
                            device.deviceId
                                ? 'border-[var(--nutrivera-shell-accent)] bg-[var(--nutrivera-shell-accent)]'
                                : ''}"
                        >
                            {#if selectedDevice == device.deviceId}
                                <IconCheck class="text-[var(--nutrivera-shell-accent-ink)]" />
                            {/if}
                        </div>
                        <div class="space-y-1 min-w-0">
                            <div class="text-lg bold truncate leading-tight">
                                {StringUtils.normalizeDeviceName(device.label)}
                            </div>
                            {#if device.deviceId === selectedDevice}
                                <Chip class="nutrivera-entry-muted">{$LL.camera.active()}</Chip>
                            {:else}
                                <Chip class="nutrivera-entry-muted">{$LL.camera.disabled()}</Chip>
                            {/if}
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>
